import { useBreakpoint } from "@chakra-ui/react";
import dayjs from "dayjs";
import type {
  APIListingAgentUpdateEntry,
  APIListingApplicantFeedbackEntry,
  APIListingEventFeedbackEntry,
} from "models/types/api-listing";
import { CardRecordMeta } from "components/cards/card-record-meta";
import { EventOrFeedbackTypeTag } from "modules/vendor-portal/components/event-or-feedback-type-tag";
import { FooterText } from "modules/vendor-portal/screens/overview/components/feedback/footer/footer-text";
import { dateFormats } from "utils/date";

type PriceReductionFooterProps = {
  feedback:
    | APIListingApplicantFeedbackEntry
    | APIListingAgentUpdateEntry
    | APIListingEventFeedbackEntry;
};

export function PriceReductionFooter({ feedback }: PriceReductionFooterProps) {
  const breakpoint = useBreakpoint({ ssr: false });
  const isMobile = breakpoint === "base" || breakpoint === "sm";

  return (
    <CardRecordMeta>
      <EventOrFeedbackTypeTag type={feedback.type} />

      {"date_of" in feedback && (
        <FooterText
          text={dayjs(feedback.date_of).format(dateFormats.dayMonthYear)}
        />
      )}

      {isMobile ? null : <FooterText text={`Agent ${feedback.agent.name}`} />}
    </CardRecordMeta>
  );
}
